export enum ProviderTypeEnum {
  Government = 'government',
  Commercial = 'commercial',
}
